import { GoogleMap } from "@react-google-maps/api";
import React from "react";
import { BrowserView } from "react-device-detect";
import { useActions, useValues } from "kea";

import profilelogic from "src/store/profile";
import { maplogic } from "src/store/global";

import checkRole from "../../../utils/checkRole";
import DrawGeofence from "./DrawGeofence";
import DrawTools from "./DrawingManager";
import DrawTracker from "./DrawVehicle";
import DrawAsset from "./DrawAsset";
import ScriptLoaded from "./ScriptLoaded";

const containerStyle = {
	width: "100%",
	height: "100%",
};

// const API_KEY = "AIzaSyA70zJWR77juUCNgsMZvg67ubyBagsTsVw";

const google = window.google;

function GMaps() {
	const { profile } = useValues(profilelogic);
	const { vehicles } = useValues(maplogic);

	const handleMapsLoad = (m) => {
		global.gmap = m;
		var bounds = new window.google.maps.LatLngBounds();
		if (vehicles.length === 0) {
			bounds.extend({
				lat: -9.278097,
				lng: 109.413165,
			});
			bounds.extend({
				lat: -45.270798,
				lng: 159.02278,
			});
			m.fitBounds(bounds);
			return;
		}
		let minlat = 360;
		let maxlat = -360;
		let minlng = 360;
		let maxlng = -360;
		vehicles.forEach((e) => {
			if (e.tracker && e.tracker.status && e.tracker.status.length > 0) {
				const pos = e.tracker.status[0];
				minlat = pos.latitude < minlat ? pos.latitude : minlat;
				maxlat = pos.latitude > maxlat ? pos.latitude : maxlat;
				minlng = pos.longitude < minlng ? pos.longitude : minlng;
				maxlng = pos.longitude > maxlng ? pos.longitude : maxlng;
			}
		});
		bounds.extend({
			lat: maxlat,
			lng: maxlng,
		});

		bounds.extend({
			lat: minlat,
			lng: minlng,
		});
		m.fitBounds(bounds);
	};

	const handleFocus = () => {
		console.log("focused clicked");
	};

	return (
		<ScriptLoaded>
			<GoogleMap
				// ref={(ref) => {
				// 	if (ref && ref.state && ref.state.map) {
				// 		global.gmap = ref.state.map;
				// 	}
				// }}
				options={{
					clickableIcons: false,
					mapTypeControl: true,
					fullscreenControl: true,
					fullscreenControlOptions: {
						position: google.maps.ControlPosition.BOTTOM_RIGHT,
					},
				}}
				zoom={10}
				id="map"
				mapContainerStyle={containerStyle}
				onLoad={handleMapsLoad}
				onFocus={handleFocus}
			>
				<DrawTracker />
				<DrawAsset />
				<BrowserView>
					<DrawTools />
				</BrowserView>
				{checkRole(profile, ["GeofenceEdit"]) && <DrawGeofence />}
			</GoogleMap>
		</ScriptLoaded>
	);
}

export default GMaps;
